export default {
    registerTitle: 'Regístrate aqui',
    register: 'Registrarte',
    registerWithGoogle: 'Regístrate con Google',
    registerWithOutlook: 'Regístrate con Outlook',
    registerWithApple: 'Regístrate con Apple',
    registerError: 'Ha ocurrido un error al registrarte',
    userRegistered: 'Este usuario ya se encuentra registrado en el sistema.',
    completeRegistration: 'Completa tu registro',
    send: 'Enviar',
    registerSuccess: 'Registro exitoso',

};
